module.exports = __webpack_public_path__ + "img/ico-checkmark-white.9c16c312.svg";